const HomePage = () => import('@/views/dashboard/HomePage.vue')

export default {
  path: '/',
  name: 'Home',
  component: HomePage,
  meta: {
    requireAuth: true
  }
}
